import styled from "styled-components";
import React from "react";
import { CircularProgress } from "@mui/material";
import { ThemeProvider, createTheme } from "@mui/material/styles";

const LoadingWallContainer = styled.div`
  position: fixed;
  direction: vertical;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100%;
  width: 100%;
  background-color: #ecebff;
  top: 0;
  left: 0;
  z-index: 1000;
  overflow: auto;
  flex-direction: column;
`;

const theme = createTheme({
  palette: {
    primary: {
      main: "#1e173f",
    },
  },
});

function ThickLoadingWall() {
  return (
    <ThemeProvider theme={theme}>
      <LoadingWallContainer>
        <CircularProgress color="primary" size={60} />
        <div className="just-a-moment">Just a moment ...</div>
      </LoadingWallContainer>
    </ThemeProvider>
  );
}

export default ThickLoadingWall;
